//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'taskList',
  data() {
    return {
      tabtype: 'waiting',
      tabcate: '',
      list: [],
      loading: false,
      finished: false,
      pager: {
        pageIndex: 1,
        pageSize: 10,
        rowsCount: 99,
        start: 0
      }
    };
  },
  created() {
    if (this.$route.query.taskId) {
      this.$router.replace('/taskManage/detail?id=' + this.$route.query.taskId)
    }
  },
  methods: {
    getCateData() {
      this.list = []
      this.pager.pageIndex = 1
      this.loading = false
      this.finished = false
      this.getData()
    },
    getData() {
      let postData = {
        pager: {
          ...this.pager,

        },
        queryMap: {
          taskType: this.tabcate,
          taskRecordStatus: this.tabtype
        },
        queryMapObject: {}
      }
      console.log(postData);
      this.loading = true
      this.axios
        .post(
          "/worktask/wxcp/task/recordList", postData
        )
        .then((res) => {
          // this.$toast.clear();
          console.log(res)
          if (res.data.code == 0 && res.data.data && res.data.data.list.length > 0) {

            this.list = this.list.concat(res.data.data.list)
            this.pager.pageIndex++
            // 加载状态结束
            this.loading = false;
            this.finished = false;
          } else {
            this.loading = false;
            this.finished = true;
          }

        });
    }, switchCate(tabcate) {
      this.tabcate = tabcate;
      this.list = []
      this.pager.pageIndex = 1
      this.loading = false
      this.finished = false
      this.getData()


    },
    goDetail(item) {
      let _this = this
      if (item.taskInfo.taskType == 'birthday') {
        this.$router.push('/taskManage/birthDetail?id=' + item.id)
      }else if (item.taskInfo.taskType == 'assess') {
        this.axios
        .get(
          "/worktask/wxcp/task/getRecord?id=" + item.id
        )
        .then((res) => {
          // this.$toast.clear();
          console.log(res)
          if(res.data.data && res.data.data.inputMap && res.data.data.inputMap[0] && res.data.data.inputMap[0].modelId){
            _this.$router.push('/storeManagement/placesadjustment?assessId=' + res.data.data.inputMap[0].modelId)
          }
        });
      } else {
        this.$router.push('/taskManage/detail?id=' + item.id)
      }

    }
  },
  activated() {
    window.document.title = '任务管理';
    this.list = []
    this.pager.pageIndex = 1
    this.loading = false
    this.finished = false
    this.getData()
  },

  mounted() {
    document.title = "任务管理";
  },
};
